import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint, FaTruckMoving } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  const [lugares, setLugares] = useState([]);
  const [filteredLugares, setFilteredLugares] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [terceroNombre, setTerceroNombre] = useState('');
  const [filteredFallecidos, setFilteredFallecidos] = useState([]);
  const [searchNumero, setSearchNumero] = useState("");

  const [searchSepultura, setSearchSepultura] = useState("");
  const [searchSepulturaIdx, setSearchSepulturaIdx] = useState('');
    
  const itemsPerPage = 10;
  
  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  /*
  useEffect(() => {
    if (searchSepultura) {
      const filtered = sepulturas.filter(sepultura =>
        sepultura.numero.toString().includes(searchSepultura)
      );
      setFilteredSepulturas(filtered);
    } else {
      setFilteredSepulturas([]);
    }
  }, [searchSepultura, sepulturas]);

 */ 
  useEffect(() => {
    let filtered = sepulturas;
  
    if (searchSepultura) {
      filtered = filtered.filter(sepultura =>
        sepultura.numero.toString().includes(searchSepultura)
      );
    }
  
    if (searchSepulturaIdx) {
      filtered = filtered.filter(sepultura =>
        sepultura.id?.toString().includes(searchSepulturaIdx)
      );
    }
  
    setFilteredSepulturas(filtered);
  }, [searchSepultura, searchSepulturaIdx, sepulturas]);
  

  
  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros'); // Ajusta la URL según tu API
      setTerceros(response.data);
      setFilteredTerceros(response.data);
    } catch (err) {
      console.error('Error al obtener terceros:', err);
    }
  };
  
  const getTerceroNombre = (terceroId) => {
    const tercero = terceros.find(t => t.documento.toString() === terceroId.toString());
    return tercero ? tercero.nombre : 'Desconocido';
  };


  // Llamar a la función cuando el componente se monte
  useEffect(() => {
    fetchTerceros();
  }, []);
  
  
  useEffect(() => {
    const filtered = terceros.filter(tercero =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.includes(searchTercero)
    );
    setFilteredTerceros(filtered);
  }, [searchTercero, terceros]);
  
  const fetchLugares = async () => {
    try {
      const response = await axios.get('/lugares'); // Ajusta la URL según tu API
      setLugares(response.data);
      setFilteredLugares(response.data);
    } catch (err) {
      console.error('Error al obtener lugares:', err);
    }
  };
  
  
  useEffect(() => {
    fetchLugares();
  }, []);
  
    
  useEffect(() => {
    const filtered = lugares.filter((lugar) =>
      lugar.id.toString().includes(searchSepulturaId.toString()) ||
      (typeof lugar.descripcion === 'string' && 
       lugar.descripcion.toLowerCase().includes(searchSepulturaId.toString().toLowerCase()))
    );
    setFilteredLugares(filtered);
  }, [searchSepulturaId, lugares]);
  

  useEffect(() => {
    if (searchFallecido) {
      const filtered = terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchFallecido.toLowerCase()) ||
        tercero.documento.toString().includes(searchFallecido)
      );
      setFilteredFallecidos(filtered);
    } else {
      setFilteredFallecidos([]);
    }
  }, [searchFallecido, terceros]);
  



  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  /* NO APARECEN LOS QUE HAN SIDO TRASLADADOS
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 
  */

  const fetchFallecidos = async (sepulturaId) => {
    try {
        const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
        
        // Elimina el filtro para incluir todos los fallecidos
        setFallecidos(response.data);
        
        setSelectedSepultura(sepulturaId);
        setShowModal(true);
    } catch (err) {
        console.error('Error fetching fallecidos:', err);
        setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
};




  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

   const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
  
      return (
        (!searchTercero || sep.terceroId.toString().includes(searchTercero)) &&
        (!searchSepulturaId || sep.lugareId.toString() === searchSepulturaId) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
  
    setFilteredSepulturas(filtered);
  };
  
  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, searchSepulturaId, sepulturas, startDate, endDate]);
  
  
  const filterTerceros = (searchTerm) => {
    if (!searchTerm) {
      setFilteredTerceros(terceros);
    } else {
      setFilteredTerceros(
        terceros.filter((tercero) =>
          tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tercero.documento.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  };
  
  const handleOpenModal = (terceroId) => {
    const nombre = getTerceroNombre(terceroId);
    setTerceroNombre(nombre);
    setModalOpen(true);
  };

  const handleSelectSepultura = (numero) => {
    setSearchSepultura(numero); // Actualiza el input con el número seleccionado
    setFilteredSepulturas([]); // Limpia la lista de sugerencias
  //  fetchFallecidosBySepultura(numero); // Llama a una función para buscar fallecidos (si es necesario)
  };
  

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

  <div className="grid grid-cols-2 gap-4 p-4 bg-gray-100 rounded-lg shadow-md">
  {/* Buscar por Tercero */}
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchTercero(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* Buscar por Fallecido */}
  <div className="flex">
    <input
      type="text"
      placeholder="Buscar por fallecido documento..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    <button
      className="bg-blue-600 text-white p-2 ml-2 rounded-lg hover:bg-blue-700"
      onClick={searchFallecidosByTerceroId}
    >
      <FaSearch />
    </button>
  </div>

  {/* Buscar por fallecido nombre/documento */}
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por fallecido documento o nombre..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredFallecidos.length > 0 && searchFallecido && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredFallecidos.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchFallecido(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* Buscar lugar por código o descripción */}
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar lugar por código o descripción..."
      value={searchSepulturaId}
      onChange={(e) => setSearchSepulturaId(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredLugares.length > 0 && searchSepulturaId && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredLugares.map((lugar) => (
          <div
            key={lugar.id}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchSepulturaId(lugar.id.toString())}
          >
            {lugar.descripcion} - {lugar.id}
          </div>
        ))}
      </div>
    )}
  </div>

  {/* Buscar por número de sepultura 
  <div>
    <input
      type="text"
      placeholder="Buscar por número de sepultura..."
      value={searchSepultura}
      onChange={(e) => setSearchSepultura(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
  </div>

*/}
 
 <div> 
    <input
      type="text"
      placeholder="Buscar por número de sepultura..."
      value={searchSepultura}
      onChange={(e) => setSearchSepultura(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm mb-2"
    />
    </div>

    <div>
    <input
      type="text"
      placeholder="Buscar por ID de sepultura..."
      value={searchSepulturaIdx}
      onChange={(e) => setSearchSepulturaIdx(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
</div>




  {/* Concesiones */}
  <div className="col-span-2 flex items-center space-x-4">
    <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
    <input
      type="number"
      placeholder="Ingrese años de concesión"
      value={x}
      onChange={(e) => setX(e.target.value)}
      className="border p-2 w-1/12 text-sm rounded-lg shadow-sm"
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>
</div>




{/* 
      <div className="relative w-full">
  <input
    type="text"
    placeholder="Buscar por Tercero documento..."
    value={searchTercero}
    onChange={(e) => setSearchTercero(e.target.value)}
    className="border p-2 w-full text-sm"
  />
  {filteredTerceros.length > 0 && searchTercero && (
    <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
      {filteredTerceros.map((tercero) => (
        <div
          key={tercero.documento}
          className="p-2 cursor-pointer hover:bg-gray-200"
          onClick={() => setSearchTercero(tercero.documento)}
        >
          {tercero.nombre} - {tercero.documento}
        </div>
      ))}
    </div>
  )}
</div>


<div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
  </div>


<div className="relative w-full">
  <input
    type="text"
    placeholder="Buscar por fallecido documento o nombre..."
    value={searchFallecido}
    onChange={(e) => setSearchFallecido(e.target.value)}
    className="border p-2 w-full text-sm"
  />
  {filteredFallecidos.length > 0 && searchFallecido && (
    <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
      {filteredFallecidos.map((tercero) => (
        <div
          key={tercero.documento}
          className="p-2 cursor-pointer hover:bg-gray-200"
          onClick={() => setSearchFallecido(tercero.documento)}
        >
          {tercero.nombre} - {tercero.documento}
        </div>
      ))}
    </div>
  )}
</div>
 


  <div className="relative w-full">
  <input
    type="text"
    placeholder="Buscar lugar por codigo o descripción..."
    value={searchSepulturaId}
    onChange={(e) => setSearchSepulturaId(e.target.value)}
    className="border p-2 w-full text-sm"
  />
 
  {filteredLugares.length > 0 && searchSepulturaId && (
    <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
      {filteredLugares.map((lugar) => (
        <div
          key={lugar.id}
          className="p-2 cursor-pointer hover:bg-gray-200"
          onClick={() => setSearchSepulturaId(lugar.id.toString())}
        >
          {lugar.descripcion} - {lugar.id}
        </div>
      ))}
    </div>
  )}
</div>

<div className="relative w-full">
  <input
    type="text"
    placeholder="Buscar por número de sepultura..."
    value={searchSepultura}
    onChange={(e) => setSearchSepultura(e.target.value)}
    className="border p-2 w-full text-sm"    
  />   
</div>


      <div className="flex items-center space-x-4 w-full">
      <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
     
       <input
         type="number"
         placeholder="Ingrese años de concesión"
         value={x}
         onChange={(e) => setX(e.target.value)}
         className="border p-2 w-1/12 text-sm"
         
       />

        <input
          type="date"
          className="border p-2 rounded w-1/5"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
       />
        <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
        />
   

        </div>
*/}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
              
              <td 
                 className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
                      onClick={() => handleOpenModal(sep.terceroId)}
                >
                    {sep.terceroId}
              </td>


                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {modalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
            <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
            <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                onClick={() => setModalOpen(false)}
            >
                Cerrar
            </button>
         </div>
       </div>
       )}

      </div>

      <div className="flex justify-center space-x-4 mt-4">
  <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    className={`px-4 py-2 rounded ${
      currentPage === 1 ? 'bg-gray-300' : 'bg-blue-500 text-white hover:bg-blue-600'
    }`}
  >
    Anterior
  </button>

  <span className="self-center text-sm">
    Página {currentPage} de {totalPages}
  </span>

  <button
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
    className={`px-4 py-2 rounded ${
      currentPage === totalPages ? 'bg-gray-300' : 'bg-blue-500 text-white hover:bg-blue-600'
    }`}
  >
    Siguiente
  </button>
</div>


     {/*
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
      */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>

 <table className="w-full text-sm">
  <thead className="bg-blue-500 text-white">
    <tr>
      <th className="px-2 py-1">ID</th>
      <th className="px-2 py-1">Tercero ID</th>
      <th className="px-2 py-1">Fecha Fallecimiento</th>
      <th className="px-2 py-1">Funeraria</th>
      <th className="px-2 py-1">Hora Defunción</th>
      <th className="px-2 py-1">Observaciones</th>
      <th className="px-2 py-1">Traslado ID</th> 
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {fallecidos.length > 0 ? (
      fallecidos.map((fallecido) => (
        <tr
          key={fallecido.id}
          className={fallecido.trasladoId !== 0 ? "bg-yellow-300" : ""}
        >
          <td className="px-2 py-1">{fallecido.id}</td>

          <td
            className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
            onClick={() => handleOpenModal(fallecido.terceroId)}
          >
            {fallecido.terceroId}
          </td>

          <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
          <td className="px-2 py-1">{fallecido.funeraria}</td>
          <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
          <td className="px-2 py-1">{fallecido.observaciones}</td>
          
          {/* Mostrar trasladoId con ícono si es distinto de 0 */}
          <td className="px-2 py-1 flex items-center gap-2">
            {fallecido.trasladoId}  
            {fallecido.trasladoId !== 0 && <FaTruckMoving className="w-4 h-4 text-gray-700" />}
          </td> 
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center py-2">
          No hay fallecidos registrados.
        </td>
      </tr>
    )}
  </tbody>
</table>





{/* con color diferente si hay traslado
  <table className="w-full text-sm">
  <thead className="bg-blue-500 text-white">
    <tr>
      <th className="px-2 py-1">ID</th>
      <th className="px-2 py-1">Tercero ID</th>
      <th className="px-2 py-1">Fecha Fallecimiento</th>
      <th className="px-2 py-1">Funeraria</th>
      <th className="px-2 py-1">Hora Defunción</th>
      <th className="px-2 py-1">Observaciones</th>
      <th className="px-2 py-1">Traslado ID</th> 
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {fallecidos.length > 0 ? (
      fallecidos.map((fallecido) => (
        <tr
          key={fallecido.id}
          className={fallecido.trasladoId !== 0 ? "bg-red-400" : ""}
        >
          <td className="px-2 py-1">{fallecido.id}</td>

          <td
            className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
            onClick={() => handleOpenModal(fallecido.terceroId)}
          >
            {fallecido.terceroId}
          </td>

          <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
          <td className="px-2 py-1">{fallecido.funeraria}</td>
          <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
          <td className="px-2 py-1">{fallecido.observaciones}</td>
          <td className="px-2 py-1">{fallecido.trasladoId}</td> 
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center py-2">
          No hay fallecidos registrados.
        </td>
      </tr>
    )}
  </tbody>
</table>

*/}


  {/* anterior    
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                  
                  <td 
                      className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
                          onClick={() => handleOpenModal(fallecido.terceroId)}
                   >
                      {fallecido.terceroId}
                  </td>


                  
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
*/}
            {modalOpen && (
           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
              <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
              <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
               onClick={() => setModalOpen(false)}
              >
               Cerrar
              </button>
             </div>
           </div>
           )}

            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}



/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint, FaTruckMoving } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  const [lugares, setLugares] = useState([]);
  const [filteredLugares, setFilteredLugares] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [terceroNombre, setTerceroNombre] = useState('');
  const [filteredFallecidos, setFilteredFallecidos] = useState([]);
  const [searchNumero, setSearchNumero] = useState("");

  const [searchSepultura, setSearchSepultura] = useState("");
  
  
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  
  useEffect(() => {
    if (searchSepultura) {
      const filtered = sepulturas.filter(sepultura =>
        sepultura.numero.toString().includes(searchSepultura)
      );
      setFilteredSepulturas(filtered);
    } else {
      setFilteredSepulturas([]);
    }
  }, [searchSepultura, sepulturas]);


  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros'); // Ajusta la URL según tu API
      setTerceros(response.data);
      setFilteredTerceros(response.data);
    } catch (err) {
      console.error('Error al obtener terceros:', err);
    }
  };
  
  const getTerceroNombre = (terceroId) => {
    const tercero = terceros.find(t => t.documento.toString() === terceroId.toString());
    return tercero ? tercero.nombre : 'Desconocido';
  };


  // Llamar a la función cuando el componente se monte
  useEffect(() => {
    fetchTerceros();
  }, []);
  
  
  useEffect(() => {
    const filtered = terceros.filter(tercero =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.includes(searchTercero)
    );
    setFilteredTerceros(filtered);
  }, [searchTercero, terceros]);
  
  const fetchLugares = async () => {
    try {
      const response = await axios.get('/lugares'); // Ajusta la URL según tu API
      setLugares(response.data);
      setFilteredLugares(response.data);
    } catch (err) {
      console.error('Error al obtener lugares:', err);
    }
  };
  
  
  useEffect(() => {
    fetchLugares();
  }, []);
  
    
  useEffect(() => {
    const filtered = lugares.filter((lugar) =>
      lugar.id.toString().includes(searchSepulturaId.toString()) ||
      (typeof lugar.descripcion === 'string' && 
       lugar.descripcion.toLowerCase().includes(searchSepulturaId.toString().toLowerCase()))
    );
    setFilteredLugares(filtered);
  }, [searchSepulturaId, lugares]);
  

  useEffect(() => {
    if (searchFallecido) {
      const filtered = terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchFallecido.toLowerCase()) ||
        tercero.documento.toString().includes(searchFallecido)
      );
      setFilteredFallecidos(filtered);
    } else {
      setFilteredFallecidos([]);
    }
  }, [searchFallecido, terceros]);
  



  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
 

  const fetchFallecidos = async (sepulturaId) => {
    try {
        const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
        
        // Elimina el filtro para incluir todos los fallecidos
        setFallecidos(response.data);
        
        setSelectedSepultura(sepulturaId);
        setShowModal(true);
    } catch (err) {
        console.error('Error fetching fallecidos:', err);
        setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
};




  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

   const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
  
      return (
        (!searchTercero || sep.terceroId.toString().includes(searchTercero)) &&
        (!searchSepulturaId || sep.lugareId.toString() === searchSepulturaId) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
  
    setFilteredSepulturas(filtered);
  };
  
  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, searchSepulturaId, sepulturas, startDate, endDate]);
  
  
  const filterTerceros = (searchTerm) => {
    if (!searchTerm) {
      setFilteredTerceros(terceros);
    } else {
      setFilteredTerceros(
        terceros.filter((tercero) =>
          tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tercero.documento.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  };
  
  const handleOpenModal = (terceroId) => {
    const nombre = getTerceroNombre(terceroId);
    setTerceroNombre(nombre);
    setModalOpen(true);
  };

  const handleSelectSepultura = (numero) => {
    setSearchSepultura(numero); // Actualiza el input con el número seleccionado
    setFilteredSepulturas([]); // Limpia la lista de sugerencias
  //  fetchFallecidosBySepultura(numero); // Llama a una función para buscar fallecidos (si es necesario)
  };
  

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

  <div className="grid grid-cols-2 gap-4 p-4 bg-gray-100 rounded-lg shadow-md">
  
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchTercero(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

 
  <div className="flex">
    <input
      type="text"
      placeholder="Buscar por fallecido documento..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    <button
      className="bg-blue-600 text-white p-2 ml-2 rounded-lg hover:bg-blue-700"
      onClick={searchFallecidosByTerceroId}
    >
      <FaSearch />
    </button>
  </div>

 
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por fallecido documento o nombre..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredFallecidos.length > 0 && searchFallecido && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredFallecidos.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchFallecido(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

 
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar lugar por código o descripción..."
      value={searchSepulturaId}
      onChange={(e) => setSearchSepulturaId(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredLugares.length > 0 && searchSepulturaId && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredLugares.map((lugar) => (
          <div
            key={lugar.id}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchSepulturaId(lugar.id.toString())}
          >
            {lugar.descripcion} - {lugar.id}
          </div>
        ))}
      </div>
    )}
  </div>

  
  <div>
    <input
      type="text"
      placeholder="Buscar por número de sepultura..."
      value={searchSepultura}
      onChange={(e) => setSearchSepultura(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
  </div>

  
  <div className="col-span-2 flex items-center space-x-4">
    <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
    <input
      type="number"
      placeholder="Ingrese años de concesión"
      value={x}
      onChange={(e) => setX(e.target.value)}
      className="border p-2 w-1/12 text-sm rounded-lg shadow-sm"
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>
</div>


      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
              
              <td 
                 className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
                      onClick={() => handleOpenModal(sep.terceroId)}
                >
                    {sep.terceroId}
              </td>


                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {modalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
            <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
            <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                onClick={() => setModalOpen(false)}
            >
                Cerrar
            </button>
         </div>
       </div>
       )}

      </div>
     
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>

 <table className="w-full text-sm">
  <thead className="bg-blue-500 text-white">
    <tr>
      <th className="px-2 py-1">ID</th>
      <th className="px-2 py-1">Tercero ID</th>
      <th className="px-2 py-1">Fecha Fallecimiento</th>
      <th className="px-2 py-1">Funeraria</th>
      <th className="px-2 py-1">Hora Defunción</th>
      <th className="px-2 py-1">Observaciones</th>
      <th className="px-2 py-1">Traslado ID</th> 
    </tr>
  </thead>
  <tbody className="bg-white divide-y divide-gray-200">
    {fallecidos.length > 0 ? (
      fallecidos.map((fallecido) => (
        <tr
          key={fallecido.id}
          className={fallecido.trasladoId !== 0 ? "bg-yellow-300" : ""}
        >
          <td className="px-2 py-1">{fallecido.id}</td>

          <td
            className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
            onClick={() => handleOpenModal(fallecido.terceroId)}
          >
            {fallecido.terceroId}
          </td>

          <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
          <td className="px-2 py-1">{fallecido.funeraria}</td>
          <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
          <td className="px-2 py-1">{fallecido.observaciones}</td>
          
         
          <td className="px-2 py-1 flex items-center gap-2">
            {fallecido.trasladoId}  
            {fallecido.trasladoId !== 0 && <FaTruckMoving className="w-4 h-4 text-gray-700" />}
          </td> 
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center py-2">
          No hay fallecidos registrados.
        </td>
      </tr>
    )}
  </tbody>
</table>



            {modalOpen && (
           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
              <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
              <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
               onClick={() => setModalOpen(false)}
              >
               Cerrar
              </button>
             </div>
           </div>
           )}

            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/

/* ultimo
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);
  const [searchSepulturaId, setSearchSepulturaId] = useState('');
  const [lugares, setLugares] = useState([]);
  const [filteredLugares, setFilteredLugares] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [terceroNombre, setTerceroNombre] = useState('');
  const [filteredFallecidos, setFilteredFallecidos] = useState([]);
  const [searchNumero, setSearchNumero] = useState("");

  const [searchSepultura, setSearchSepultura] = useState("");
  
  
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  
  useEffect(() => {
    if (searchSepultura) {
      const filtered = sepulturas.filter(sepultura =>
        sepultura.numero.toString().includes(searchSepultura)
      );
      setFilteredSepulturas(filtered);
    } else {
      setFilteredSepulturas([]);
    }
  }, [searchSepultura, sepulturas]);


  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros'); // Ajusta la URL según tu API
      setTerceros(response.data);
      setFilteredTerceros(response.data);
    } catch (err) {
      console.error('Error al obtener terceros:', err);
    }
  };
  
  const getTerceroNombre = (terceroId) => {
    const tercero = terceros.find(t => t.documento.toString() === terceroId.toString());
    return tercero ? tercero.nombre : 'Desconocido';
  };


  // Llamar a la función cuando el componente se monte
  useEffect(() => {
    fetchTerceros();
  }, []);
  
  
  useEffect(() => {
    const filtered = terceros.filter(tercero =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.includes(searchTercero)
    );
    setFilteredTerceros(filtered);
  }, [searchTercero, terceros]);
  
  const fetchLugares = async () => {
    try {
      const response = await axios.get('/lugares'); // Ajusta la URL según tu API
      setLugares(response.data);
      setFilteredLugares(response.data);
    } catch (err) {
      console.error('Error al obtener lugares:', err);
    }
  };
  
  
  useEffect(() => {
    fetchLugares();
  }, []);
  
    
  useEffect(() => {
    const filtered = lugares.filter((lugar) =>
      lugar.id.toString().includes(searchSepulturaId.toString()) ||
      (typeof lugar.descripcion === 'string' && 
       lugar.descripcion.toLowerCase().includes(searchSepulturaId.toString().toLowerCase()))
    );
    setFilteredLugares(filtered);
  }, [searchSepulturaId, lugares]);
  

  useEffect(() => {
    if (searchFallecido) {
      const filtered = terceros.filter(tercero =>
        tercero.nombre.toLowerCase().includes(searchFallecido.toLowerCase()) ||
        tercero.documento.toString().includes(searchFallecido)
      );
      setFilteredFallecidos(filtered);
    } else {
      setFilteredFallecidos([]);
    }
  }, [searchFallecido, terceros]);
  



  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

   const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
  
      return (
        (!searchTercero || sep.terceroId.toString().includes(searchTercero)) &&
        (!searchSepulturaId || sep.lugareId.toString() === searchSepulturaId) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
  
    setFilteredSepulturas(filtered);
  };
  
  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, searchSepulturaId, sepulturas, startDate, endDate]);
  
  
  const filterTerceros = (searchTerm) => {
    if (!searchTerm) {
      setFilteredTerceros(terceros);
    } else {
      setFilteredTerceros(
        terceros.filter((tercero) =>
          tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tercero.documento.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  };
  
  const handleOpenModal = (terceroId) => {
    const nombre = getTerceroNombre(terceroId);
    setTerceroNombre(nombre);
    setModalOpen(true);
  };

  const handleSelectSepultura = (numero) => {
    setSearchSepultura(numero); // Actualiza el input con el número seleccionado
    setFilteredSepulturas([]); // Limpia la lista de sugerencias
  //  fetchFallecidosBySepultura(numero); // Llama a una función para buscar fallecidos (si es necesario)
  };
  

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

  <div className="grid grid-cols-2 gap-4 p-4 bg-gray-100 rounded-lg shadow-md">
  
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por Tercero documento..."
      value={searchTercero}
      onChange={(e) => setSearchTercero(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredTerceros.length > 0 && searchTercero && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredTerceros.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchTercero(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

  
  <div className="flex">
    <input
      type="text"
      placeholder="Buscar por fallecido documento..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    <button
      className="bg-blue-600 text-white p-2 ml-2 rounded-lg hover:bg-blue-700"
      onClick={searchFallecidosByTerceroId}
    >
      <FaSearch />
    </button>
  </div>

  
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar por fallecido documento o nombre..."
      value={searchFallecido}
      onChange={(e) => setSearchFallecido(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredFallecidos.length > 0 && searchFallecido && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredFallecidos.map((tercero) => (
          <div
            key={tercero.documento}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchFallecido(tercero.documento)}
          >
            {tercero.nombre} - {tercero.documento}
          </div>
        ))}
      </div>
    )}
  </div>

  
  <div className="relative">
    <input
      type="text"
      placeholder="Buscar lugar por código o descripción..."
      value={searchSepulturaId}
      onChange={(e) => setSearchSepulturaId(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
    {filteredLugares.length > 0 && searchSepulturaId && (
      <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
        {filteredLugares.map((lugar) => (
          <div
            key={lugar.id}
            className="p-2 cursor-pointer hover:bg-gray-200"
            onClick={() => setSearchSepulturaId(lugar.id.toString())}
          >
            {lugar.descripcion} - {lugar.id}
          </div>
        ))}
      </div>
    )}
  </div>

  
  <div>
    <input
      type="text"
      placeholder="Buscar por número de sepultura..."
      value={searchSepultura}
      onChange={(e) => setSearchSepultura(e.target.value)}
      className="border p-2 w-5/6 text-sm rounded-lg shadow-sm"
    />
  </div>

  
  <div className="col-span-2 flex items-center space-x-4">
    <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
    <input
      type="number"
      placeholder="Ingrese años de concesión"
      value={x}
      onChange={(e) => setX(e.target.value)}
      className="border p-2 w-1/12 text-sm rounded-lg shadow-sm"
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={startDate}
      onChange={(e) => setStartDate(e.target.value)}
    />
    <input
      type="date"
      className="border p-2 rounded-lg w-1/5 shadow-sm"
      value={endDate}
      onChange={(e) => setEndDate(e.target.value)}
    />
  </div>
</div>


      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
              
              <td 
                 className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
                      onClick={() => handleOpenModal(sep.terceroId)}
                >
                    {sep.terceroId}
              </td>


                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {modalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
            <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
            <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                onClick={() => setModalOpen(false)}
            >
                Cerrar
            </button>
         </div>
       </div>
       )}

      </div>
     
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                  
                  <td 
                      className="px-2 py-1 cursor-pointer text-blue-600 hover:underline"
                          onClick={() => handleOpenModal(fallecido.terceroId)}
                   >
                      {fallecido.terceroId}
                  </td>


                  
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {modalOpen && (
           <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h2 className="text-lg font-semibold mb-4">Información del Tercero</h2>
              <p className="text-gray-700">Nombre: <span className="font-bold">{terceroNombre}</span></p>
              <button 
                className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
               onClick={() => setModalOpen(false)}
              >
               Cerrar
              </button>
             </div>
           </div>
           )}

            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/

/* ultimo demo
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [terceros, setTerceros] = useState([]);
  const [filteredTerceros, setFilteredTerceros] = useState([]);

  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  
  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros'); // Ajusta la URL según tu API
      setTerceros(response.data);
      setFilteredTerceros(response.data);
    } catch (err) {
      console.error('Error al obtener terceros:', err);
    }
  };
  
  
  // Llamar a la función cuando el componente se monte
  useEffect(() => {
    fetchTerceros();
  }, []);
  
  useEffect(() => {
    const filtered = terceros.filter(tercero =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.includes(searchTercero)
    );
    setFilteredTerceros(filtered);
  }, [searchTercero, terceros]);
  



  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
      
      return (
        sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
    
    setFilteredSepulturas(filtered);
  };

  const filterTerceros = (searchTerm) => {
    if (!searchTerm) {
      setFilteredTerceros(terceros);
    } else {
      setFilteredTerceros(
        terceros.filter((tercero) =>
          tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tercero.documento.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  };
  
 
  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

      <div className="relative w-full">
  <input
    type="text"
    placeholder="Buscar por Tercero documento..."
    value={searchTercero}
    onChange={(e) => setSearchTercero(e.target.value)}
    className="border p-2 w-full text-sm"
  />
  {filteredTerceros.length > 0 && searchTercero && (
    <div className="absolute z-10 w-full bg-white border border-gray-300 max-h-40 overflow-y-auto shadow-md">
      {filteredTerceros.map((tercero) => (
        <div
          key={tercero.documento}
          className="p-2 cursor-pointer hover:bg-gray-200"
          onClick={() => setSearchTercero(tercero.documento)}
        >
          {tercero.nombre} - {tercero.documento}
        </div>
      ))}
    </div>
  )}
</div>
    
   

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex items-center space-x-4 w-full">
      <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
     
       <input
         type="number"
         placeholder="Ingrese años de concesión"
         value={x}
         onChange={(e) => setX(e.target.value)}
         className="border p-2 w-1/12 text-sm"
         
       />

        <input
          type="date"
          className="border p-2 rounded w-1/5"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
       />
        <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
        />
   

        </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
                <td className="px-2 py-1">{sep.terceroId}</td>
                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                      <td className="px-2 py-1">{fallecido.terceroId}</td>
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [terceros, setTerceros] = useState([]);
const [filteredTerceros, setFilteredTerceros] = useState([]);

  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  
  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTerceros = async () => {
    try {
      const response = await axios.get('/terceros'); // Ajusta la URL según tu API
      setTerceros(response.data);
      setFilteredTerceros(response.data);
    } catch (err) {
      console.error('Error al obtener terceros:', err);
    }
  };
  
  
  // Llamar a la función cuando el componente se monte
  useEffect(() => {
    fetchTerceros();
  }, []);
  
  useEffect(() => {
    const filtered = terceros.filter(tercero =>
      tercero.nombre.toLowerCase().includes(searchTercero.toLowerCase()) ||
      tercero.documento.includes(searchTercero)
    );
    setFilteredTerceros(filtered);
  }, [searchTercero, terceros]);
  



  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
      
      return (
        sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
    
    setFilteredSepulturas(filtered);
  };

  const filterTerceros = (searchTerm) => {
    if (!searchTerm) {
      setFilteredTerceros(terceros);
    } else {
      setFilteredTerceros(
        terceros.filter((tercero) =>
          tercero.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
          tercero.documento.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  };
  
 
  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

     
      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por Tercero documento..."
          value={searchTercero}
          onChange={(e) => setSearchTercero(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={filterSepulturas}
        >
          <FaSearch />
        </button>


<select
    value={searchTercero}
    onChange={(e) => setSearchTercero(e.target.value)}
    className="border p-2 rounded w-1/3"
  >
    <option value="">Seleccione un tercero</option>
    {filteredTerceros.map(tercero => (
      <option key={tercero.documento} value={tercero.documento}>
        {tercero.nombre} - {tercero.documento}
      </option>
    ))}
  </select>


         
      </div>


      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex items-center space-x-4 w-full">
      <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
     
       <input
         type="number"
         placeholder="Ingrese años de concesión"
         value={x}
         onChange={(e) => setX(e.target.value)}
         className="border p-2 w-1/12 text-sm"
         
       />

        <input
          type="date"
          className="border p-2 rounded w-1/5"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
       />
        <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
        />
   

        </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
                <td className="px-2 py-1">{sep.terceroId}</td>
                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                      <td className="px-2 py-1">{fallecido.terceroId}</td>
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/



/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [x, setX] = useState(5); // establecer un valor por defecto, como 5 años
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas,startDate,endDate]);

  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep => {
      const concesionFecha = new Date(sep.fechaConcesion);
      const concesionMasXAnios = new Date(concesionFecha.setFullYear(concesionFecha.getFullYear() + x));
      
      return (
        sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase()) &&
        (!startDate || concesionMasXAnios >= new Date(startDate)) &&
        (!endDate || concesionMasXAnios <= new Date(endDate))
      );
    });
    
    setFilteredSepulturas(filtered);
  };


  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

     
      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por Tercero documento..."
          value={searchTercero}
          onChange={(e) => setSearchTercero(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={filterSepulturas}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex items-center space-x-4 w-full">
      <p className="font-semibold whitespace-nowrap">Concesiones años y vencimientos:</p>
     
       <input
         type="number"
         placeholder="Ingrese años de concesión"
         value={x}
         onChange={(e) => setX(e.target.value)}
         className="border p-2 w-1/12 text-sm"
         
       />

        <input
          type="date"
          className="border p-2 rounded w-1/5"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
       />
        <input
            type="date"
            className="border p-2 rounded w-1/5"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
        />
   

        </div>
 

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
                <td className="px-2 py-1">{sep.terceroId}</td>
                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>
 
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                      <td className="px-2 py-1">{fallecido.terceroId}</td>
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/
 
/* CORRECTO
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas]);

  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };
 

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep =>
      sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );
    setFilteredSepulturas(filtered);
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por Tercero documento..."
          value={searchTercero}
          onChange={(e) => setSearchTercero(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={filterSepulturas}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
                <td className="px-2 py-1">{sep.terceroId}</td>
                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>

      <Link
        to="/sepulturas/nueva"
        className="mt-3 inline-block bg-blue-500 text-white px-4 py-2 rounded text-sm"
      >
        <FaPlus /> Agregar Sepultura
      </Link>

      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                      <td className="px-2 py-1">{fallecido.terceroId}</td>
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/

/* CORRECTO
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [searchFallecido, setSearchFallecido] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas]);

  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const searchFallecidosByTerceroId = async () => {
    try {
      // Paso 1: Realizar la búsqueda por terceroId
      const fallecidosResponse = await axios.get(`/fallecidosc/`, {
        params: { terceroId: searchFallecido } // El terceroId es pasado como parámetro
      });
      
      const fallecidosFound = fallecidosResponse.data;
  
      // Si no se encuentra ningún fallecido con ese terceroId, mostramos un mensaje de error
      if (!fallecidosFound || fallecidosFound.length === 0) {
        setError('No se encontró ningún fallecido con ese código de tercero.');
        setFilteredSepulturas([]);
        return;
      }
  
      // Paso 2: Filtrar las sepulturas que tengan un fallecido con ese terceroId
      const filteredSepulturas = sepulturas.filter(sep =>
        fallecidosFound.some(fallecido => fallecido.terceroId === searchFallecido && fallecido.sepulturaId === sep.id)
      );
  
      // Actualizamos el estado con las sepulturas filtradas
      setFilteredSepulturas(filteredSepulturas);
    } catch (err) {
      console.error('Error al buscar fallecidos:', err);
      setError('Error al buscar fallecidos. Intente de nuevo.');
      setFilteredSepulturas([]);
    }
  };
  
  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      const filteredFallecidos = response.data.filter(fallecido => fallecido.trasladoId === 0);
      
      setFallecidos(filteredFallecidos);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  }; 

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };
 

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep =>
      sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );
    setFilteredSepulturas(filtered);
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };

  const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
  const currentItems = filteredSepulturas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="container mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por Tercero documento..."
          value={searchTercero}
          onChange={(e) => setSearchTercero(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={filterSepulturas}
        >
          <FaSearch />
        </button>
      </div>

      <div className="flex mb-3">
        <input
          type="text"
          placeholder="Buscar por fallecido documento..."
          value={searchFallecido}
          onChange={(e) => setSearchFallecido(e.target.value)}
          className="border p-2 w-full text-sm"
        />
        <button
          className="bg-blue-500 text-white p-2 ml-2"
          onClick={searchFallecidosByTerceroId}
        >
          <FaSearch />
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-blue-500 text-white">
            <tr>
              <th className="px-2 py-1">ID</th>
              <th className="px-2 py-1">Tipo</th>
              <th className="px-2 py-1">Lugar</th>
              <th className="px-2 py-1">Serie</th>
              <th className="px-2 py-1">Número</th>
              <th className="px-2 py-1">Tercero</th>
              <th className="px-2 py-1">Acciones</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {currentItems.map((sep) => (
              <tr key={sep.id} className="hover:bg-gray-50">
                <td className="px-2 py-1">{sep.id}</td>
                <td className="px-2 py-1">{sep.tipoId}</td>
                <td className="px-2 py-1">{sep.lugareId}</td>
                <td className="px-2 py-1">{sep.serie}</td>
                <td className="px-2 py-1">{sep.numero}</td>
                <td className="px-2 py-1">{sep.terceroId}</td>
                <td className="px-2 py-1 flex space-x-1">
                  <button
                    onClick={() => fetchFallecidos(sep.id)}
                    className="text-purple-600 hover:text-purple-900"
                  >
                    <FaUser /> Ver Fallecidos
                  </button>
                  <Link
                    to={`/home/sepulturas/${sep.id}`}
                    className="text-blue-600 hover:text-blue-900"
                  >
                    <FaEye /> Ver
                  </Link>
                  <Link
                    to={`/home/sepulturas/edit/${sep.id}`}
                    className="text-green-600 hover:text-green-900"
                  >
                    <FaEdit /> Editar
                  </Link>
                  <button
                    onClick={() => handlePrint(sep.id)}
                    className="text-gray-600 hover:text-gray-900"
                  >
                    <FaPrint />
                  </button>
                  <button
                    onClick={() => deleteSepultura(sep.id)}
                    className="text-red-600 hover:text-red-900"
                  >
                    <FaTrash /> Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      
      <div className="flex justify-center space-x-2 mt-3">
        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentPage(index + 1)}
            className={`px-3 py-1 text-sm ${
              currentPage === index + 1
                ? 'bg-blue-500 text-white'
                : 'bg-gray-300'
            }`}
          >
            {index + 1}
          </button>
        ))}
      </div>

      <Link
        to="/sepulturas/nueva"
        className="mt-3 inline-block bg-blue-500 text-white px-4 py-2 rounded text-sm"
      >
        <FaPlus /> Agregar Sepultura
      </Link>

      
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
            <h2 className="text-lg font-bold mb-3">
              Fallecidos en Sepultura {selectedSepultura}
            </h2>
            <table className="w-full text-sm">
              <thead className="bg-blue-500 text-white">
                <tr>
                  <th className="px-2 py-1">ID</th>
                  <th className="px-2 py-1">Tercero ID</th>
                  <th className="px-2 py-1">Fecha Fallecimiento</th>
                  <th className="px-2 py-1">Funeraria</th>
                  <th className="px-2 py-1">Hora Defunción</th>
                  <th className="px-2 py-1">Observaciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {fallecidos.length > 0 ? (
                  fallecidos.map((fallecido) => (
                    <tr key={fallecido.id}>
                      <td className="px-2 py-1">{fallecido.id}</td>
                      <td className="px-2 py-1">{fallecido.terceroId}</td>
                      <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                      <td className="px-2 py-1">{fallecido.funeraria}</td>
                      <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                      <td className="px-2 py-1">{fallecido.observaciones}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">
                      No hay fallecidos registrados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <button
              onClick={() => setShowModal(false)}
              className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
*/

/*
import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaPrint } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import axios from '../api/axios';

export default function SepulturasTable() {
  const [sepulturas, setSepulturas] = useState([]);
  const [filteredSepulturas, setFilteredSepulturas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTercero, setSearchTercero] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [fallecidos, setFallecidos] = useState([]);
  const [selectedSepultura, setSelectedSepultura] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const itemsPerPage = 10;

  useEffect(() => {
    fetchSepulturas();
  }, []);

  useEffect(() => {
    filterSepulturas();
  }, [searchTercero, sepulturas]);

  const fetchSepulturas = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get('/sepulturasc');
      setSepulturas(response.data);
      setFilteredSepulturas(response.data);
    } catch (err) {
      setError('Error al cargar las sepulturas. Intente de nuevo.');
      console.error('Error fetching sepulturas:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchFallecidos = async (sepulturaId) => {
    try {
      const response = await axios.get(`/sepulturasc/${sepulturaId}/fallecidosSepultura`);
      setFallecidos(response.data);
      setSelectedSepultura(sepulturaId);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching fallecidos:', err);
      setError('Error al cargar los fallecidos. Intente de nuevo.');
    }
  };

  const deleteSepultura = async (sepulturaId) => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta sepultura?')) {
      try {
        await axios.delete(`/sepulturasc/${sepulturaId}`);
        setSepulturas(sepulturas.filter(sep => sep.id !== sepulturaId));
      } catch (err) {
        console.error('Error al eliminar la sepultura:', err);
        setError('Error al eliminar la sepultura. Intente de nuevo.');
      }
    }
  };

  const filterSepulturas = () => {
    let filtered = sepulturas.filter(sep =>
      sep.terceroId.toLowerCase().includes(searchTercero.toLowerCase())
    );
    setFilteredSepulturas(filtered);
  };

  const handlePrint = async (id) => {
    try {
      const response = await axios.get(`/sepulturasc/${id}/pdftituloc`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Sepultura_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al imprimir titulo:', err);
      alert('Error al generar el PDF titulo.');
    }
  };


const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
const currentItems = filteredSepulturas.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);

return (
  <div className="container mx-auto px-4 py-6">
    <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

    <div className="flex mb-3">
      <input
        type="text"
        placeholder="Buscar por Tercero ID..."
        value={searchTercero}
        onChange={(e) => setSearchTercero(e.target.value)}
        className="border p-2 w-full text-sm"
      />
      <button
        className="bg-blue-500 text-white p-2 ml-2"
        onClick={filterSepulturas}
      >
        <FaSearch />
      </button>
    </div>

    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-blue-500 text-white">
          <tr>
            <th className="px-2 py-1">ID</th>
            <th className="px-2 py-1">Tipo</th>
            <th className="px-2 py-1">Lugar</th>
            <th className="px-2 py-1">Serie</th>
            <th className="px-2 py-1">Número</th>
            <th className="px-2 py-1">Tercero</th>
            <th className="px-2 py-1">Acciones</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {currentItems.map((sep) => (
            <tr key={sep.id} className="hover:bg-gray-50">
              <td className="px-2 py-1">{sep.id}</td>
              <td className="px-2 py-1">{sep.tipoId}</td>
              <td className="px-2 py-1">{sep.lugareId}</td>
              <td className="px-2 py-1">{sep.serie}</td>
              <td className="px-2 py-1">{sep.numero}</td>
              <td className="px-2 py-1">{sep.terceroId}</td>
              <td className="px-2 py-1 flex space-x-1">
                <button
                  onClick={() => fetchFallecidos(sep.id)}
                  className="text-purple-600 hover:text-purple-900"
                >
                  <FaUser /> Ver Fallecidos
                </button>
                <Link
                  to={`/home/sepulturas/${sep.id}`}
                  className="text-blue-600 hover:text-blue-900"
                >
                  <FaEye /> Ver
                </Link>
                <Link
                  to={`/home/sepulturas/edit/${sep.id}`}
                  className="text-green-600 hover:text-green-900"
                >
                  <FaEdit /> Editar
                </Link>
                <button
                  onClick={() => handlePrint(sep.id)}
                  className="text-gray-600 hover:text-gray-900"
                >
                  <FaPrint />
                </button>
                <button
                  onClick={() => deleteSepultura(sep.id)}
                  className="text-red-600 hover:text-red-900"
                >
                  <FaTrash /> Borrar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="flex justify-center space-x-2 mt-3">
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => setCurrentPage(index + 1)}
          className={`px-3 py-1 text-sm ${
            currentPage === index + 1
              ? "bg-blue-500 text-white"
              : "bg-gray-300"
          }`}
        >
          {index + 1}
        </button>
      ))}
    </div>
    <Link
      to="/sepulturas/nueva"
      className="mt-3 inline-block bg-blue-500 text-white px-4 py-2 rounded text-sm"
    >
      <FaPlus /> Agregar Sepultura
    </Link>
    {showModal && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
        <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
          <h2 className="text-lg font-bold mb-3">
            Fallecidos en Sepultura {selectedSepultura}
          </h2>
          <table className="w-full text-sm">
            <thead className="bg-blue-500 text-white">
              <tr>
                <th className="px-2 py-1">ID</th>
                <th className="px-2 py-1">Tercero ID</th>
                <th className="px-2 py-1">Fecha Fallecimiento</th>
                <th className="px-2 py-1">Funeraria</th>
                <th className="px-2 py-1">Hora Defunción</th>
                <th className="px-2 py-1">Observaciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {fallecidos.length > 0 ? (
                fallecidos.map((fallecido) => (
                  <tr key={fallecido.id}>
                    <td className="px-2 py-1">{fallecido.id}</td>
                    <td className="px-2 py-1">{fallecido.terceroId}</td>
                    <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                    <td className="px-2 py-1">{fallecido.funeraria}</td>
                    <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                    <td className="px-2 py-1">{fallecido.observaciones}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-2">
                    No hay fallecidos registrados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <button
            onClick={() => setShowModal(false)}
            className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    )}
  </div>
);
}

*/
/*
const totalPages = Math.ceil(filteredSepulturas.length / itemsPerPage);
const currentItems = filteredSepulturas.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

return (
  <div className="container mx-auto px-4 py-6">
    <h1 className="text-xl font-bold mb-6 text-center">Gestión de Sepulturas</h1>

    <div className="flex mb-3">
      <input 
        type="text" 
        placeholder="Buscar por Tercero ID..." 
        value={searchTercero} 
        onChange={(e) => setSearchTercero(e.target.value)} 
        className="border p-2 w-full text-sm"
      />
      <button className="bg-blue-500 text-white p-2 ml-2" onClick={filterSepulturas}>
        <FaSearch />
      </button>
    </div>
    
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-2 py-1">ID</th>
            <th className="px-2 py-1">Tipo</th>
            <th className="px-2 py-1">Lugar</th>
            <th className="px-2 py-1">Serie</th>
            <th className="px-2 py-1">Número</th>
            <th className="px-2 py-1">Tercero</th>     
            <th className="px-2 py-1">Acciones</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {currentItems.map((sep) => (
            <tr key={sep.id} className="hover:bg-gray-50">
              <td className="px-2 py-1">{sep.id}</td>
              <td className="px-2 py-1">{sep.tipoId}</td>
              <td className="px-2 py-1">{sep.lugareId}</td>
              <td className="px-2 py-1">{sep.serie}</td>
              <td className="px-2 py-1">{sep.numero}</td>
              <td className="px-2 py-1">{sep.terceroId}</td>
              <td className="px-2 py-1 flex space-x-1">
                <button onClick={() => fetchFallecidos(sep.id)} className="text-purple-600 hover:text-purple-900">
                  <FaUser /> Ver Fallecidos
                </button>
                <Link to={`/home/sepulturas/${sep.id}`} className="text-blue-600 hover:text-blue-900">
                  <FaEye /> Ver
                </Link>
                <Link to={`/home/sepulturas/edit/${sep.id}`} className="text-green-600 hover:text-green-900">
                  <FaEdit /> Editar
                </Link>
                <button onClick={() => handlePrint(sep.id)} className="text-gray-600 hover:text-gray-900"><FaPrint /></button>
                <button onClick={() => deleteSepultura(sep.id)} className="text-red-600 hover:text-red-900">
                  <FaTrash /> Borrar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div className="flex justify-center space-x-2 mt-3">
      {[...Array(totalPages)].map((_, index) => (
        <button key={index} onClick={() => setCurrentPage(index + 1)} className={`px-3 py-1 text-sm ${currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}>
          {index + 1}
        </button>
      ))}
    </div>
    <Link to="/sepulturas/nueva" className="mt-3 inline-block bg-blue-500 text-white px-4 py-2 rounded text-sm">
      <FaPlus /> Agregar Sepultura
    </Link>
    {showModal && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center">
        <div className="bg-white p-6 rounded-lg shadow-lg overflow-x-auto">
          <h2 className="text-lg font-bold mb-3">Fallecidos en Sepultura {selectedSepultura}</h2>
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-2 py-1">ID</th>
                <th className="px-2 py-1">Tercero ID</th>
                <th className="px-2 py-1">Fecha Fallecimiento</th>
                <th className="px-2 py-1">Funeraria</th>
                <th className="px-2 py-1">Hora Defunción</th>
                <th className="px-2 py-1">Observaciones</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {fallecidos.length > 0 ? (
                fallecidos.map(fallecido => (
                  <tr key={fallecido.id}>
                    <td className="px-2 py-1">{fallecido.id}</td>
                    <td className="px-2 py-1">{fallecido.terceroId}</td>
                    <td className="px-2 py-1">{fallecido.fechaFallecimiento}</td>
                    <td className="px-2 py-1">{fallecido.funeraria}</td>
                    <td className="px-2 py-1">{fallecido.horaDefuncion}</td>
                    <td className="px-2 py-1">{fallecido.observaciones}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-2">No hay fallecidos registrados.</td>
                </tr>
              )}
            </tbody>
          </table>
          <button onClick={() => setShowModal(false)} className="mt-3 bg-red-500 text-white px-4 py-2 rounded text-sm">Cerrar</button>
        </div>
      </div>
    )}
  </div>
);
}
*/
